import React, { Component } from "react";
import {Link} from "react-router-dom";

import './Routes.scss';
import MyContext from '../MyContext.jsx';


class Routes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routes : [],
      
    }
  }

  componentDidMount(){  
    this.context.setLocation({
      latitude : '',
      longitude : ''
    });  
    this.getRoutes();
   
    var obj_this=this;
    $(".routes_page_container").on("click",".remove_route_button",function(){
      if(!confirm("Are you sure you want to delete this route ?")){
        return;
      }
      const route_id = $(this).attr("route_id");
      obj_this.deleteRoutes(route_id);

    });

  }

  getRoutes() {
   
  var obj_this = this;
  const url = `${process.env.REACT_APP_SSS}/api/getRoutes`;
  this.context.loading(1);
  $.ajax({
    url : url,
    data : {
      sid : this.context.user_details.sid
    },
    type : "POST"
  }).done(function(return_data){
    // console.log(return_data);
    if(return_data.status == "success"){
      const routes = return_data.routes;
     
      obj_this.setState({
        routes: routes,
       
      });
      obj_this.context.loading(0);
    }else{
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    }
  }).fail(function(){
    obj_this.context.loading(0);
    alert("Network error");
  });
  }

  deleteRoutes(route_id){

    var obj_this = this;
    
    const url = `${process.env.REACT_APP_SSS}/api/deleteRoutes`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        route_id : route_id
      },
      type : "POST"
    }).done(function(return_data){
        // console.log(return_data);
      if(return_data.status == "success"){
        obj_this.getRoutes();
        alert("Route deleted")
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="routes_page_container noselect">
          <div className="header_spacer"></div>
          <div className="routes_container">
            <div className="page_header">
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Routes</div>
              <Link className="new_route_button" to="/routes/new"> 
                <i className="fa fa-plus"></i> New</Link>
            </div>
            <div className="list_blocks_container">
              <div className="lists_container">
                {this.state.routes.map((item,idx)=>(
                  <div className="single_route_container" key={idx}>
                    <div className="route_customer_name_delete_button_container">
                      <div className="routes_date_container">
                        <div className="route_no">{item.day.slice(0,3).toUpperCase() }</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="route_customer_name"> {item.route_name.toUpperCase() }{' - ('+item.count+')'}</div>
                        {/* <div className="routes_button_container"
                        >
                         
                        </div> */}
                        <Link className="edit_button"
                            to={"/routes/edit/"+item.id}
                           
                          >&nbsp;
                            <i className="fa fa-pencil-alt" style={{fontSize: "14px"}} route_id = {item.id}></i>
                          </Link>
                        <i className="remove_route_button fas fa-times" route_id={item.id}
                          // onClick={this.handleRemoveSchedule(idx)}
                        ></i>
                      </div>
                      <div></div>
                    </div>
                  </div>

                ))}
              </div>
             

            </div>

          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Routes;
Routes.contextType = MyContext;
